var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.934 9.848C26.8406 9.84694 25.7922 9.41211 25.0191 8.63894C24.2459 7.86577 23.8111 6.81743 23.81 5.724V0H5.382C3.9546 0 2.58568 0.567034 1.57636 1.57635C0.567034 2.58568 0 3.9546 0 5.38199V37.826C0.00211967 39.252 0.570084 40.6189 1.57917 41.6265C2.58827 42.6341 3.95598 43.2 5.382 43.2H27.504C28.9304 43.2 30.2984 42.6338 31.3075 41.6258C32.3167 40.6177 32.8844 39.2504 32.886 37.824V9.848H27.934Z",
    fill: "#005FAD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8861 9.848H27.9341C26.8406 9.84694 25.7923 9.41211 25.0191 8.63894C24.2459 7.86577 23.8111 6.81743 23.8101 5.724V0L32.8861 9.848Z",
    fill: "#005FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7879 34.1201H11.7799C10.0059 34.1201 8.56787 35.5582 8.56787 37.3321V44.7881C8.56787 46.562 10.0059 48.0001 11.7799 48.0001H36.7879C38.5618 48.0001 39.9999 46.562 39.9999 44.7881V37.3321C39.9999 35.5582 38.5618 34.1201 36.7879 34.1201Z",
    fill: "#005FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8122 42.6741V44.1281H14.3062V42.6741H15.8122Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0239 42.02V44.128H16.5679V38.114H18.9239C19.6399 38.114 20.1845 38.2913 20.5579 38.646C20.7474 38.8319 20.8954 39.0557 20.9923 39.3029C21.0891 39.55 21.1326 39.8149 21.1199 40.08C21.1262 40.4298 21.0392 40.775 20.8679 41.08C20.6942 41.3785 20.4351 41.6182 20.1239 41.768C19.7497 41.9465 19.3382 42.0329 18.9239 42.02H18.0239ZM19.6399 40.08C19.6399 39.5467 19.3479 39.28 18.7639 39.28H18.0239V40.846H18.7639C19.3479 40.8513 19.6399 40.596 19.6399 40.08Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.176 44.128H25.722L23.286 40.436V44.128H21.832V38.114H23.286L25.72 41.84V38.114H27.174L27.176 44.128Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.858 38.6C33.3433 38.9632 33.6694 39.5 33.768 40.098H32.228C32.127 39.8838 31.9648 39.7043 31.762 39.582C31.5328 39.4462 31.2703 39.3769 31.004 39.382C30.7971 39.3735 30.5908 39.4104 30.3997 39.4902C30.2086 39.5701 30.0373 39.6908 29.898 39.844C29.6058 40.1952 29.4572 40.6439 29.482 41.1C29.482 41.672 29.628 42.1114 29.92 42.4181C30.0841 42.5774 30.2797 42.7006 30.4943 42.7798C30.7089 42.8591 30.9377 42.8925 31.166 42.8781C31.4923 42.8837 31.8116 42.7833 32.076 42.5921C32.3453 42.3904 32.5396 42.1047 32.628 41.7801H30.792V40.734H33.846V42.2C33.7277 42.5577 33.5424 42.8897 33.3 43.1781C33.0382 43.4885 32.712 43.7383 32.344 43.91C31.9268 44.1027 31.4714 44.1984 31.012 44.1901C30.4538 44.2042 29.9017 44.0703 29.412 43.8021C28.9638 43.5508 28.5989 43.174 28.362 42.7181C28.1085 42.227 27.9813 41.6806 27.992 41.1281C27.98 40.5722 28.1072 40.0222 28.362 39.5281C28.5985 39.0732 28.9619 38.6967 29.408 38.444C29.8906 38.1782 30.4351 38.045 30.986 38.058C31.6529 38.0253 32.3117 38.2161 32.858 38.6Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 13.344H8.18994V16.094H10.9399V13.344Z",
    fill: "#005FAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 16.094H10.9419V18.844H13.6919V16.094Z",
    fill: "#005FAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4419 13.344H13.6919V16.094H16.4419V13.344Z",
    fill: "#005FAD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1919 16.094H16.4419V18.844H19.1919V16.094Z",
    fill: "#005FAD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 13.344H19.1958V16.094H21.9458V13.344Z",
    fill: "#005FAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6958 16.094H21.9458V18.844H24.6958V16.094Z",
    fill: "#005FAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 18.8401H8.18994V21.5901H10.9399V18.8401Z",
    fill: "#005FAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 21.5901H10.9419V24.3401H13.6919V21.5901Z",
    fill: "#005FAD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4419 18.8401H13.6919V21.5901H16.4419V18.8401Z",
    fill: "#005FAD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1919 21.5901H16.4419V24.3401H19.1919V21.5901Z",
    fill: "#005FAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 18.8401H19.1958V21.5901H21.9458V18.8401Z",
    fill: "#005FAD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6958 21.5901H21.9458V24.3401H24.6958V21.5901Z",
    fill: "#005FAD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 24.3621H8.18994V27.1121H10.9399V24.3621Z",
    fill: "#005FAD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 27.1121H10.9419V29.8621H13.6919V27.1121Z",
    fill: "#005FAD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4419 24.3621H13.6919V27.1121H16.4419V24.3621Z",
    fill: "#005FAD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1919 27.1121H16.4419V29.8621H19.1919V27.1121Z",
    fill: "#005FAD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 24.3621H19.1958V27.1121H21.9458V24.3621Z",
    fill: "#005FAD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6958 27.1121H21.9458V29.8621H24.6958V27.1121Z",
    fill: "#005FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/PNG.2a43e6df10869ff06e65d4e3824c583e.svg";
export { ForwardRef as ReactComponent };